var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge rounded-pill font-size-11",class:{
          'badge-soft-success': _vm.status === 'paid',
          'badge-soft-warning': _vm.status === 'partially paid',
          'badge-soft-info': _vm.status === 'deposited',
          'badge-soft-info': _vm.status === 'written off',
          'badge-soft-danger': _vm.status === 'unpaid',
          'badge-soft-dark': _vm.status === 'cancelled',
        }},[_vm._v(" "+_vm._s(_vm.payment_status))])
}
var staticRenderFns = []

export { render, staticRenderFns }